import { RootState } from "@/store/store";
import { ResourceType } from "@/services/cloudchipr.api";
import { generateAutomationFoundResourcesMasterGridId } from "@/components/pages/automations/common/components/found-resources/components/AutomationsFoundResourcesCard";
import { gridResourcesEmsSelector } from "@/store/resources-grid/selectors/resource-data/costs/gridResourcesEmsSelector";

export const scheduleAllResourcesEmsSelector = (
  state: RootState,
  resourceTypes: ResourceType[],
): number => {
  return resourceTypes.reduce(
    (sum, resourceType) => {
      const masterGridId =
        generateAutomationFoundResourcesMasterGridId(resourceType);

      const spending = gridResourcesEmsSelector(state, masterGridId);

      return spending + sum;
    },

    0,
  );
};
